define('AllBrands.BrandByLetter.View', [
    'all_brands_brand_by_letter.tpl',
    'Backbone',
    'Utils',
    'underscore'
], function AllBrandsBrandByLetterView(
    allBrandsBrandByLetterTpl,
    Backbone,
    Utils,
    _
) {
    'use strict';

    return Backbone.View.extend({
        template: allBrandsBrandByLetterTpl,
        initialize: function initialize(options) {
            this.facetId = options.brandConfig.facetId;
            this.translator = options.translator;
        },
        getContext: function getContext() {
            var self = this;
            var values = [];
            var originalValues = _.isArray(this.model.get('values'))
                ? this.model.get('values')
                : [this.model.get('values')];

            _.each(originalValues, function each(value) {
                if (value.url) {
                    value.link = self.translator.cloneForFacetId(self.facetId, value.url).getUrl();
                    value.displayName =
                        value.label || decodeURIComponent(value.url) || Utils.translate('(none)');
                    values.push(value);
                }
            });

            return {
                letter: this.model.get('letter'),
                values: values
            };
        }
    });
});
